import { createContext } from 'react';

export type HeaderContextType = {
  height: number;
  isMenuOpened: boolean;
  isCartOpened: boolean;
  isSearchOpened: boolean;
  setIsMenuOpened: (value: boolean) => void;
  setIsCardOpened: (value: boolean) => void;
  setIsSearchOpened: (value: boolean) => void;
};

const HeaderContext = createContext<HeaderContextType | null>(null);

export default HeaderContext;
